import { RailsBlock } from '@sls-react/typings/services/rails/tile';
import { useQuery } from 'react-query';
import { fetchFacetItemsNoMeta } from '@sls-react/api/items';
import React from 'react';
import HorizontalScrollItemGrid from '@sls-react/components/legos/HorizontalScrollItemGrid';
import ItemThumbnail from '@sls-react/components/ItemThumbnail/ItemThumbnail';

const ItemGridHorizontalScrollBlock = ({ block }: { block: RailsBlock }) => {
  const { data: items } = useQuery(
    ['horizontal-item-block', block.query],
    () => fetchFacetItemsNoMeta(block.query),
    {
      refetchOnMount: false,
    },
  );

  if (!items) {
    return null;
  }

  return (
    <HorizontalScrollItemGrid>
      {items.map((item, i) => (
        <ItemThumbnail
          key={item.id}
          // When this block is one of the first few rendered, send position to load the image eagerly
          // to optimize the LCP web-vital
          position={block.id! < 3 ? i : undefined}
          item={item}
        />
      ))}
    </HorizontalScrollItemGrid>
  );
};

export default ItemGridHorizontalScrollBlock;
